module.exports = __webpack_public_path__ + "img/elementwidths_jaka.d81bc870.png";